export default __webpack_public_path__ + "static/media/0xf13bfc42bfcc421db1fd471ec49bb865cede7270.d604b320.webp";